import bg from "../../../../src/courses/making-of-a-course/odyssey_zoom_bg.png";
import * as React from 'react';
export default {
  bg,
  React
};